import React, { ReactNode, createContext, useState } from 'react';
import { Spin } from 'antd';

interface ILoadingContext {
  show: () => void;
  hide: () => void;
  isLoading: boolean;
}

const LoadingContext = createContext<ILoadingContext | null>(null);

type LoadingContextProps = {
  children: ReactNode;
};

const LoadingProvider = (props: LoadingContextProps) => {
  const [isLoadingGlobal, setIsLoadingGlobal] = useState<boolean>(false);

  const contextValue = {
    isLoading: isLoadingGlobal,
    show: () => setIsLoadingGlobal(true),
    hide: () => setIsLoadingGlobal(false),
  };

  return (
    <LoadingContext.Provider value={contextValue}>
      {props.children}
      {isLoadingGlobal && (
        <div className='loading_wrapper_global'>
          <Spin size='large' />
        </div>
      )}
    </LoadingContext.Provider>
  );
};

export { LoadingContext, LoadingProvider };
